import { cn } from "../../lib/cn";

export function Field({ className, children, ...props }) {
  return (
    <div className={cn("space-y-1.5", className)} {...props}>
      {children}
    </div>
  );
}

export function FieldLabel({ className, children, htmlFor, ...props }) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn("block text-xs font-medium text-muted-foreground", className)}
      {...props}
    >
      {children}
    </label>
  );
}

export function FieldHint({ className, children, ...props }) {
  if (!children) return null;
  return (
    <p
      className={cn("text-xs text-muted-foreground", className)}
      {...props}
    >
      {children}
    </p>
  );
}

export function FieldError({ className, children, ...props }) {
  if (!children) return null;
  return (
    <p
      className={cn("text-xs text-red-600", className)}
      {...props}
    >
      {children}
    </p>
  );
}
